import { Injectable, inject } from '@angular/core';
import { TenantComponentsState } from '../../states/tenant-components.state';
import { RefreshTenantComponentsStateCommand } from './refresh-tenant-components-state.command';

/**
 * Refresh Tenant Components State Use Case.
 *
 * Syncs the shared TenantComponentsState singleton right after a successful
 * update, so consumers such as NavBarProvider and portalAccessGuard reflect
 * the new flags without requiring a full page reload.
 */
@Injectable({ providedIn: 'root' })
export class RefreshTenantComponentsStateUseCase {
  private readonly _state = inject(TenantComponentsState);

  public execute(command: RefreshTenantComponentsStateCommand): void {
    this._state.set(
      command.sharedServicesPortalEnabled,
      command.employeeRelationsPortalEnabled,
      this._state.employeePortalEnabled(),
    );
  }
}
